import { type ReactNode, type JSXElementConstructor } from 'react';

import { cn } from '@/lib/cn';

type AlertProps = {
  title?: string;
  type?: 'info' | 'warning' | 'error';
  icon?: JSXElementConstructor<{ className: string }>;
  description?: ReactNode;
  className?: string;
};

export const Alert = ({ title, type = 'warning', description, icon: Icon, className }: AlertProps) => {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-md border px-4 py-3 text-sm',
        {
          'border-amber-200 bg-amber-100': type === 'warning',
          'border-red-200 bg-red-100': type === 'error',
          'border-blue-200 bg-blue-100': type === 'info'
        },
        className
      )}
    >
      {Icon && (
        <Icon
          className={cn('size-5', {
            'text-red-500!': type === 'error',
            'text-amber-500!': type === 'warning',
            'text-blue-500!': type === 'info'
          })}
        />
      )}
      <div>
        {title && <h5 className='text-content-title mb-1 font-semibold'>{title}</h5>}
        {description && <div className='text-content-title'>{description}</div>}
      </div>
    </div>
  );
};
